import { render, staticRenderFns } from "./EmpresasParceirasTabela.vue?vue&type=template&id=17287449"
import script from "./EmpresasParceirasTabela.vue?vue&type=script&lang=js"
export * from "./EmpresasParceirasTabela.vue?vue&type=script&lang=js"
import style0 from "./EmpresasParceirasTabela.vue?vue&type=style&index=0&id=17287449&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports